import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import axios from 'axios';

class ChromeNotification extends Component {
  static propTypes = {
    initChromeNotification: PropTypes.bool,
    getCookie: PropTypes.func,
    actions: PropTypes.object,
    webengageTitle: PropTypes.string,
  };

  static defaultProps = {
    initChromeNotification: false,
    webengageTitle: null,
    getCookie: name => {
      const value = '; ' + document.cookie;
      const parts = value.split('; ' + name + '=');
      if (parts.length === 2)
        return parts
          .pop()
          .split(';')
          .shift();
    },
  };

  constructor(props) {
    super(props);
    this.closeChromePopup = this.closeChromePopup.bind(this);
    this.isChromeNotificationSupported = this.isChromeNotificationSupported.bind(this);
    this.storeSubscriptionId = this.storeSubscriptionId.bind(this);
    this.registerChromeNotification = this.registerChromeNotification.bind(this);
    this.shoudlWrokerRegister = this.shoudlWrokerRegister.bind(this);
    this.switchChromeNotification = this.switchChromeNotification.bind(this);
    this.doWorkerRegisteration = this.doWorkerRegisteration.bind(this);
    this.pushGaEventForChromeNotif = this.pushGaEventForChromeNotif.bind(this);
  }

  componentDidMount() {
    const {webengageTitle} = this.props;
    if (webengageTitle) {
      this.initWebenageNotification();
    }
  }

  initWebenageNotification() {
    const {webengageTitle} = this.props;
    if (window && window.webengage) {
      webengage.notification.onClick(data => {
        if (data.title.indexOf(webengageTitle) !== -1) {
          this.switchChromeNotification();
        }
      });
    } else {
      setTimeout(() => {
        this.initWebenageNotification();
      }, 300);
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.initChromeNotification;
  }

  componentWillUpdate() {
    const {toggleChromeNotification} = this.props.actions; // dispatch function
    this.doWorkerRegisteration();
    toggleChromeNotification(false);
  }

  isChromeNotificationSupported() {
    // For Testing
    if (window.location.hostname === 'localhost') {
      console.log('localhost');
      return true;
    }

    if (window.location.protocol !== 'https:') {
      console.log('https');
      return false;
    }

    if (!('serviceWorker' in navigator) && !('PushManager' in window)) {
      console.log('serviceWorker:', 'serviceWorker' in navigator, '-', 'PushManager' in window);
      return false;
    }

    return true;
  }

  storeSubscriptionId(subscriptionObject) {
    let subId = '';

    if (window && localStorage) {
      if (subscriptionObject.subscriptionId) {
        subId = subscriptionObject.subscriptionId;
      } else if (subscriptionObject.endpoint) {
        subId = subscriptionObject.endpoint.substr(40, subscriptionObject.endpoint.length);
      }

      localStorage.setItem('chromeSubscriptionId', subId);
    }

    return subId;
  }

  registerChromeNotification(myCallback) {
    if (!this.isChromeNotificationSupported()) {
      return;
    }

    navigator.serviceWorker.register('/go-worker.js').then(
      () => {
        navigator.serviceWorker.ready.then(
          serviceWorkerRegistration => {
            serviceWorkerRegistration.pushManager.getSubscription().then(
              subscription => {
                if (subscription === null) {
                  serviceWorkerRegistration.pushManager.subscribe({userVisibleOnly: true}).then(
                    subs => {
                      myCallback(subs);
                    },
                    error => {
                      myCallback(null, error);
                    },
                  );
                } else {
                  // already registered
                }
              },
              reason => {
                console.log(reason);
              },
            );
          },
          reason => {
            console.log(reason);
          },
        );
      },
      err => {
        console.log(' Error while registering Service worker', err);
      },
    );
  }

  shoudlWrokerRegister(myCallback) {
    if (!this.isChromeNotificationSupported()) {
      myCallback(false);
      return;
    }

    if (localStorage && localStorage.getItem('chromeSubscriptionId')) {
      myCallback(false);
      return;
    }

    navigator.serviceWorker.register('/go-worker.js').then(
      () => {
        if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
          myCallback(false);
          return;
        }

        // Check the current Notification permission.
        // If its denied, it's a permanent block until the
        // user changes the permission
        if (Notification.permission === 'denied') {
          myCallback(false);
          return;
        }

        // Check if push messaging is supported
        if (!('PushManager' in window)) {
          myCallback(false);
          return;
        }

        navigator.serviceWorker.ready.then(
          serviceWorkerRegistration => {
            serviceWorkerRegistration.pushManager.getSubscription().then(
              subscription => {
                if (subscription === null) {
                  myCallback(true);
                } else {
                  myCallback(false, subscription);
                }
              },
              reason => {
                console.log(reason);
              },
            );
          },
          reason => {
            console.log(reason);
          },
        );
      },
      err => {
        console.log(' Error while registering Service worker', err);
      },
    );
  }

  closeChromePopup(mode) {
    this.refs.chromePopup.classList.add('dn');

    // pushGA with MODE
    this.pushGaEventForChromeNotif({
      event: 'CN-popup-closed',
      status: mode,
    });
  }

  switchChromeNotification() {
    // hide the pop-up
    this.refs.askContainer.classList.add('dn');
    this.refs.postClickContainer.classList.remove('dn');

    this.registerChromeNotification((subscriptionObject, err) => {
      // hide popup
      this.refs.chromePopup.classList.add('dn');
      this.refs.postClickContainer.classList.add('dn');

      if (!subscriptionObject && err) {
        // User Denied Permission
        this.pushGaEventForChromeNotif({
          event: 'CN-browser-disallow',
        });
        return;
      }

      const subId = this.storeSubscriptionId(subscriptionObject);

      if (this.props.webengageTitle && window.webengage) {
        webengage.webpush.prompt();
      }

      const sessionToken = this.props.getCookie('ugcAuthToken') || '';

      const paramData =
        'flavour=chrome&hash=makesNoSense&sessionToken=' + sessionToken + '&pnToken=' + subId;

      axios
        .post('https://www.goibibo.com/gns/register/?flavour=chrome&app=pigeon', paramData)
        .then(response => {
          // pushGA -> subscription sent
          if (response.data.deviceId) {
            document.cookie = 'chromeDeviceId=' + response.data.deviceId + '; path=/';
            this.pushGaEventForChromeNotif({
              event: 'CN-pigeon-register',
              status: 'success',
            });
          } else {
            this.pushGaEventForChromeNotif({
              event: 'CN-pigeon-register',
              status: 'failed',
            });
          }
        })
        .catch(error => {
          console.log(error);
          // pushGA -> subscription failed
          this.pushGaEventForChromeNotif({
            event: 'CN-pigeon-register',
            status: 'failed',
          });
        });

      // pushGA -> NOTIFICATIONS REGISTERED
      this.pushGaEventForChromeNotif({
        event: 'CN-browser-allow',
      });
    });

    // pushGA -> TurnON CLICKED
    this.pushGaEventForChromeNotif({
      event: 'CN-popup-allow',
    });
  }

  doWorkerRegisteration() {
    if (document.cookie.indexOf('chromeNotificationAttempted') !== -1) {
      return;
    }

    this.shoudlWrokerRegister((shouldReg, subscriptionObject) => {
      if (shouldReg) {
        this.refs.chromePopup.classList.remove('dn');
        document.cookie = 'chromeNotificationAttempted=true;';
        this.pushGaEventForChromeNotif({
          event: 'CN-popup-shown',
        });
      } else {
        // Already registered OR Denied

        // pushGA fire GA -> pop-up NOT shown.

        if (subscriptionObject) {
          // Already registered -> store ID in localstorage

          this.storeSubscriptionId(subscriptionObject);
        } else {
          this.pushGaEventForChromeNotif({
            event: 'CN-popup-notshown',
          });
        }
      }
    });
  }

  pushGaEventForChromeNotif(dataObj) {
    const goCtCookie = this.props.getCookie('go_ct');
    try {
      dataObj.userData = goCtCookie;
      dataLayer.push(dataObj);
    } catch (exception) {
      console.log(exception);
    }
  }

  render() {
    return (
      <section className="cromeNoteWeb dn" ref="chromePopup">
        <div className="width100 fl txtCenter" ref="askContainer">
          <i className="dib vMid ico18 white icon-bell"></i>
          <span className="dib vMid ico20 white padR20 padL10">
            Get Notified for Exclusive Deals and Offers
          </span>
          <span className="askBtn">
            <button
              className="button whiteAskBtn"
              onClick={this.closeChromePopup.bind(this, 'aml')}
            >
              Ask me Later
            </button>
          </span>
          <span className="addNoteBtn">
            <button className="button whiteDoneBtn" onClick={this.switchChromeNotification}>
              OK
            </button>
          </span>
          <span
            className="fr txtRight marginR20 padR10"
            onClick={this.closeChromePopup.bind(this, 'cross')}
          >
            <a href="javascript:void(0);" className="dib pad5 ico18">
              <i className="icon-close1 dib white"></i>
            </a>
          </span>
        </div>
        <div
          className="width100 fl txtCenter posRel dn"
          ref="postClickContainer"
          style={{left: '50px'}}
        >
          <span className="chromeArrow"></span>
          <i className="dib vMid ico18 white icon-bell padT3"></i>
          <span className="dib vMid ico20 white padR20 padL10 padT3">
            Click <strong>Allow</strong> to get exclusive deals and offers
          </span>
          <span
            className="fr txtRight marginR20 padR10 posRel"
            style={{right: '59px'}}
            onClick={this.closeChromePopup.bind(this, 'cross')}
          >
            <a href="javascript:void(0);" className="dib pad5 ico18">
              <i className="icon-close1 dib white"></i>
            </a>
          </span>
        </div>
      </section>
    );
  }
}

export default ChromeNotification;
